import { Injectable } from '@angular/core';
import { AccountMaintenancesAverageDeadlinesItem, DeadlinesTimeline, DeadlinesWhere } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DeadlinesApi {
  constructor(private readonly apollo: Apollo) { }

  public getResponseDeadlinesTimeline(where: DeadlinesWhere): Observable<DeadlinesTimeline[]> {
    return this.apollo
    .query({
      query: gql`
        query accountMaintenancesDeadlinesByDay($where: DeadlinesWhereInput!) {
          accountMaintenancesDeadlinesByDay(where: $where) {
            items {
              day
              firstVisitInPeriodCount
              firstVisitOutPeriodCount
              closedInPeriodCount
              closedOutPeriodCount
            }
          }
        }
      `,
      variables: {
        where
      }
    })
    .pipe(map((response) => {
      return response.data['accountMaintenancesDeadlinesByDay']['items'] as DeadlinesTimeline[];
    }));
  }
}
